export default "__VITE_ASSET__DGW4sFBf__"